var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClassesMediumOffline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_677_5208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.54289 12.9591C3.94844 12.0036 4.89531 11.3335 5.9987 11.3335H9.9987C11.1021 11.3335 12.0489 12.0036 12.4545 12.9591M10.6654 6.3335C10.6654 7.80625 9.47146 9.00016 7.9987 9.00016C6.52594 9.00016 5.33203 7.80625 5.33203 6.3335C5.33203 4.86074 6.52594 3.66683 7.9987 3.66683C9.47146 3.66683 10.6654 4.86074 10.6654 6.3335ZM14.6654 8.00016C14.6654 11.6821 11.6806 14.6668 7.9987 14.6668C4.3168 14.6668 1.33203 11.6821 1.33203 8.00016C1.33203 4.31826 4.3168 1.3335 7.9987 1.3335C11.6806 1.3335 14.6654 4.31826 14.6654 8.00016Z",
    stroke: "#434343",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_677_5208"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClassesMediumOffline);
export default __webpack_public_path__ + "static/media/ClassesMediumOffline.00cee7558dd86d1d3f726e9964e78307.svg";
export { ForwardRef as ReactComponent };